import type { Script } from "./script";
import type { Page } from "./page";

export interface PageCounts {
  total: number;
  uploaded: number;
  blocked: number;
  failed: number;
  needsAttention: boolean;
  fullyUploaded: boolean;
}

export interface ScriptSummary {
  script: Script;
  /** This script's own pages, page-order. Home shows a manual upload
   * trigger per script, and that trigger acts on rows, not on counts. */
  pages: Page[];
  counts: PageCounts;
  displayLabel: string;
}

export function countPages(pages: Page[]): PageCounts {
  const total = pages.length;
  const uploaded = pages.filter(p => p.uploadStatus === "uploaded").length;
  const blocked = pages.filter(p => p.uploadStatus === "blocked").length;
  const failed = pages.filter(p => p.uploadStatus === "failed").length;
  return {
    total,
    uploaded,
    blocked,
    failed,
    needsAttention: blocked > 0 || failed > 0,
    fullyUploaded: total > 0 && uploaded === total,
  };
}

export function displayLabel(script: Script): string {
  return script.label ?? "Untitled";
}

export function scriptStatusLabel(uploadEnabled: boolean, counts: PageCounts): string {
  if (counts.blocked > 0) return "Blocked";
  if (counts.failed > 0) return "Retrying";
  if (counts.total === 0) return "Not done";
  if (counts.fullyUploaded) return "Done";
  if (!uploadEnabled) return "Not done";
  return "Uploading";
}
